import type { UserManagerSettings } from "oidc-client-ts";
import { getConfig } from "../config";

/**
 * The workbench is a client of the Optimyl Identity Server (`uw-workbench-spa`). IDENTITY_URL is that server for the
 * environment, AUTH_CLIENT_ID the client id, and AUTH_API_SCOPE the audience scope the API requires
 * (`optimyl:uw-workbench`). Everyone who uses the workbench is internal, so `idp=microsoft` skips the email page and
 * goes straight to Microsoft sign-in. The role is decided by the API from the role claims the identity server relays
 * from Entra, and reaches the UI through the current-user call.
 */
export function getOidcSettings(): UserManagerSettings {
  const config = getConfig();
  if (!config.AUTH_CLIENT_ID || !config.AUTH_API_SCOPE) {
    throw new Error("AUTH_CLIENT_ID and AUTH_API_SCOPE must be set in config.json when AUTH_ENABLED is true.");
  }
  return {
    authority: config.IDENTITY_URL,
    client_id: config.AUTH_CLIENT_ID,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/logged-out`,
    response_type: "code",
    scope: `openid profile email roles offline_access ${config.AUTH_API_SCOPE}`,
    extraQueryParams: { idp: "microsoft" },
    automaticSilentRenew: true,
  };
}
